import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarLessonV1Request } from './get-grammar-lesson-v1-request';
import { getGrammarLessonV1RequestSchema } from './get-grammar-lesson-v1-request';
import type { IGetGrammarLessonV1Response } from './get-grammar-lesson-v1-response';
import { getGrammarLessonV1ResponseSchema } from './get-grammar-lesson-v1-response';

export async function getGrammarLessonV1Api(
  request: IGetGrammarLessonV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarLessonV1Response>> {
  const { slug } = getGrammarLessonV1RequestSchema.parse(request);
  return getRequest<IGetGrammarLessonV1Response>({
    path: `/grammar/lesson/${encodeURIComponent(slug)}/v1`,
    schema: getGrammarLessonV1ResponseSchema,
    options,
  });
}
